import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, PopoverController } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
import { MessagesPage } from '../../messages/messages';
import { PopupPage } from '../../popup/popup';

declare var google;


@Component({
  selector: 'page-addpoimap',
  templateUrl: 'addpoimap.html',
})
export class AddpoimapPage {
  @ViewChild('mapFull2') mapElement: ElementRef;
  Title = ''
  PoiID = '-1'
  Groups = []
  Lat = ''
  Lon = ''
  _address = ''
  _poiname = ''
  _av = '3'
  _radius = 50
  _groupID = '1'
  Map: any
  selectedModal = ''
  searchmapview: any
  buttonMultipleCLicks = false
  _copyCoords = []
  towyardflag = false
  what = ''
  garminvehicle: string = ''
  garminvehicleid = -1

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, private toastCtrl: ToastController, public alertCtrl: AlertController, public popoverCtrl: PopoverController) {

    this.Lat = navParams.get('lat')
    this.Lon = navParams.get('lon')
    this.PoiID = navParams.get('id')
    this.searchmapview = navParams.get('searchmapview')
    this.what = navParams.get('what') == undefined ? 'poi' : navParams.get('what')
    if (this.what == 'garmin') {
      this.Title = dic.l["addGarmin"]
      this.garminvehicle = this.dic.l["choosevehicle"]
    } else {
      this.Title = dic.l["addPoi"]
    }
    if (this.PoiID + '' != '-1') {
      this._poiname = navParams.get('name')
      this._av = navParams.get('available')
      this._radius = navParams.get('radius')
      this._groupID = navParams.get('groupid')
      this.Title = dic.l["editPoi"]
    }
    if (this.searchmapview == 1) {
      this.Title = dic.l["sendlocation"]
      this._groupID = '1'
      this._radius = 50
      this._av = '3'
      this._poiname = ''
    }
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad AddpoimapPage');
    this.loadPoiGroups()
    this.getAddress()
    this.initMap()
  }

  initMap() {
    var _that = this
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
      draggable: true,
    }
    this.Map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('add poi map') }, function () {
    })

    var myLatLng = { lat: parseFloat(this.Lat), lng: parseFloat(this.Lon) };


    var markerIcon = {
      url: 'assets/imgs/newpin-red.png',
      scaledSize: new google.maps.Size(38, 43),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(13, 43),
      labelOrigin: new google.maps.Point(13, 13)
    };

    /*done*/var marker = new google.maps.Marker({
      position: myLatLng,
      map: this.Map,
      draggable: true,
      icon: markerIcon,
      label: {
        //text: lbl,
        color: "#000",
        fontSize: "14px",
        fontWeight: "bold",
      }
    });
    this.Map.setCenter(myLatLng)
    google.maps.event.addListener(marker, 'dragend', function (event) {
      _that.Lat = event.latLng.lat();
      _that.Lon = event.latLng.lng();
      _that.getAddress()
    });

  }

  openBeaconVehicle(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-garmin', selected: [], callback: function (_text, _ids) {
        _that.garminvehicleid = _ids
        _that.garminvehicle = _text
      }
    });
    popover.present({ ev: _ev });
  }

  getAddress() {
    var _that = this
    this.gn.Socket.emit({ lon: this.Lon, lat: this.Lat }, function (_data) {
      _that._address = _data.address
    }, 'getreversegeocode')
  }

  loadPoiGroups() {
    var _that = this
    this.gn._Post('/api/gn/getpoigroups', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _data[0].name = _that.dic.l["Ungroupped"]
      _that.Groups = _data
    })
  }
  addnewgroup() {
    var _that = this
    let prompt = this.alertCtrl.create({
      title: this.dic.l["newpoigroup"],
      message: this.dic.l["newpoigroupname"],
      inputs: [
        {
          name: 'name',
          placeholder: this.dic.l["grname"]
        },
      ],
      buttons: [
        { text: this.dic.l["cancel"], handler: data => { } },
        {
          text: this.dic.l["Save"],
          handler: data => {
            // console.log(data);
            _that.gn.tfBtn = true;
            _that.gn._Post('/api/gn/addpoigrouop', { cid: _that.gn.crypt(_that.gn.user.ClientId), gname: _that.gn.crypt(data.name) }, function (_data) {
              _that.loadPoiGroups()
              _that.gn.tfBtn = false;
            })
          }
        }
      ]
    });
    prompt.present();
  }

  DeletePOI() {
    var _dat = {
      id: this.gn.crypt(this.PoiID),
    }
    var _that = this
    this.gn._Post('/api/gn/deletepoimap', _dat, function (_data) {
      if (_data.msg == 'ok') {
        var _cb = _that.navParams.get('cb')
        if (_cb != null) {
          _cb()
        }
        //PoiID
        var _msg = _that.dic.l["succdelpoi"]
        let toast = _that.toastCtrl.create({
          message: _msg,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        _that.navCtrl.pop()
      } else {
        let toast = _that.toastCtrl.create({ message: _that.dic.l["containorders1"] + ': ' + _data.orders + '. ' + _that.dic.l["containorders2"], duration: 6000, position: 'top' });
        toast.present();
      }
    })
  }

  savefromsearch() {
    if (this._poiname == '') {
      this._poiname = this._address
    }
    this.buttonMultipleCLicks = true
    var _dat = {
      name: this.gn.crypt(this._poiname),
      av: this.gn.crypt(this._av),
      radius: this.gn.crypt(this._radius),
      addr: this.gn.crypt(this._address),
      lat: this.gn.crypt(this.Lat),
      lon: this.gn.crypt(this.Lon),
      gid: this.gn.crypt(this._groupID),
      uid: this.gn.crypt(this.gn.user.UserId),
      cid: this.gn.crypt(this.gn.user.ClientId),
    }
    var _that = this
    this.gn._Post('/api/gn/savepoimapfromsearch', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      _that.buttonMultipleCLicks = false
      if (_cb != null) {
        _cb()
      }
      var _msg = _that.dic.l["succaddpoi"]

      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })

  }

  Save() {
    var _that = this
    if (this.what == 'garmin') {
      if (this.garminvehicleid + '' == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["entergarminvehicle"], duration: 3000, position: 'top' });
        toast.present();
        return
      }

      this.buttonMultipleCLicks = true
      var _datG = {
        name: this.gn.crypt(this._poiname),
        addr: this.gn.crypt(this._address),
        lat: this.gn.crypt(this.Lat),
        lon: this.gn.crypt(this.Lon),
        uid: this.gn.crypt(this.gn.user.UserId),
        cid: this.gn.crypt(this.gn.user.ClientId),
        vehid: this.gn.crypt(this.garminvehicleid)
      }
      this.gn._Post('/api/gn/savestopstatus', _datG, function (_data) {
        var _cb = _that.navParams.get('cb')
        _that.buttonMultipleCLicks = false

        //debugger
        if (_cb != null) {
          _cb()
        }
        //PoiID

        var _msg = _that.dic.l["succaddgarmin"]
        let toast = _that.toastCtrl.create({
          message: _msg,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        _that.navCtrl.pop()
      })
    } else {
      this.buttonMultipleCLicks = true
      var _dat = {
        id: this.gn.crypt(this.PoiID),
        name: this.gn.crypt(this._poiname),
        av: this.gn.crypt(this._av),
        radius: this.gn.crypt(this._radius),
        addr: this.gn.crypt(this._address),
        lat: this.gn.crypt(this.Lat),
        lon: this.gn.crypt(this.Lon),
        gid: this.gn.crypt(this._groupID),
        uid: this.gn.crypt(this.gn.user.UserId),
        cid: this.gn.crypt(this.gn.user.ClientId),
        towyard: this.towyardflag == true ? this.gn.crypt('1') : this.gn.crypt('0')
      }
      this.gn._Post('/api/gn/savepoimap', _dat, function (_data) {
        var _cb = _that.navParams.get('cb')
        _that.buttonMultipleCLicks = false

        //debugger
        if (_cb != null) {
          _cb()
        }
        //PoiID
        var _msg = _that.dic.l["succaddpoi"]
        if (_that.PoiID + '' != '-1') {
          _msg = _that.dic.l["succaddpoi2"]
        }
        let toast = _that.toastCtrl.create({
          message: _msg,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        _that.navCtrl.pop()
      })
    }

  }

  Send(_ev) {
    if (this.searchmapview == 1) {
      let popover = this.popoverCtrl.create(MessagesPage,
        {
          addpoimap: 1, lat: this.Lat, lon: this.Lon, poiname: this._address
        }, { cssClass: 'messages-popover' })
      popover.present({ ev: _ev });
      this.selectedModal = 'msgs'
      popover.onDidDismiss(() => {
        this.selectedModal = ''
      });
    }

    else {
      let popover = this.popoverCtrl.create(MessagesPage,
        {
          addpoimap: 1, lat: this.Lat, lon: this.Lon, poiname: this._poiname
        }, { cssClass: 'messages-popover' })
      popover.present({ ev: _ev });
      this.selectedModal = 'msgs'
      popover.onDidDismiss(() => {
        this.selectedModal = ''
      });
    }
  }

  navigateToPoiRoute() {
    var _lon = 21.427379;
    var _lat = 41.998802;
    var _url = '/'
    for (var v = 0; v < this.gn.Vehicles.length; v++) {
      var tf = false;
      if (this.gn.Vehicles[v].driver + '' == this.gn.user.UserFullName + '') {
        _lon = parseFloat(this.gn.Vehicles[v].lon)
        _lat = parseFloat(this.gn.Vehicles[v].lat)
        _url = "https://www.google.com/maps/dir/" + _lat + "," + _lon + "/" + this.Lat + "," + this.Lon + "/data=!3m1!4b1!4m2!4m1!3e0"
        document.getElementById('a-poi-' + this.PoiID).setAttribute("href", _url);
      }
    }
  }

  copyCoords(vid = -1) {
    var inp = document.createElement('input');
    document.body.appendChild(inp)
    this._copyCoords[0] = this.Lon
    this._copyCoords[1] = this.Lat

    inp.value = this._copyCoords[1] + ', ' + this._copyCoords[0]
    inp.select();
    document.execCommand('copy', false);
    inp.remove();


    let toast = this.toastCtrl.create({
      message: this.dic.l["coordcopied"],
      duration: 3000,
      position: 'top'
    });
    toast.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/mapview/addpoimap/addpoimap.ts